import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { PingService } from '@core/services/ping.service';
import { Observable, catchError, map, of, tap } from 'rxjs';
import { WhoAmIService } from 'src/app/auth/services/whoami.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private pingSvc = inject(PingService);
  private whoami = inject(WhoAmIService);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.whoami.isAuthenticated()) {
      return true;
    } else {
      return this.pingSvc.ping(undefined).pipe(
        tap(user => this.whoami.setUserAndRole(user)),
        map(() => true),
        catchError(() => {
          const message = state.url === '/new-service'
            ? 'Sign in to create your service.'
            : undefined;
          this.whoami.clearAndGoToSignin(state.url, message);
          return of(false);
        })
      );
    }
  }
}
